module.exports = function(element) {
  function resolutionBlock(el) {
    var node       = $(el)
    var url        = node.data('url')

    node.on({change: function() {
        location = url.replace('111x111', $(this).find(":checked").val())
    }});
  }

  if (!element) {
    throw new Error('Element undefined');
  }

  resolutionBlock(element);
};
